import { render } from "./AcceptanceDeliveryRequest.vue?vue&type=template&id=b15ba914"
import script from "./AcceptanceDeliveryRequest.vue?vue&type=script&lang=js"
export * from "./AcceptanceDeliveryRequest.vue?vue&type=script&lang=js"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__